import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import InsuranceReviewIcon from '@/assets/pc/insurance-review.svg?react';
import InsuranceCarIcon from '@/assets/pc/insurance-car.svg?react';
import InsurancePersonIcon from '@/assets/pc/insurance-person.svg?react';
import InsuranceFeeIcon from '@/assets/pc/insurance-fee.svg?react';
import InsuranceChatIcon from '@/assets/pc/insurance-chat.svg?react';
import BlueArrowIcon from '@/assets/pc/blue-arrow.svg?react';
import InsuranceEyeIcon from '@/assets/pc/insurance-eye.svg?react';
import { Dropdown, Menu } from 'antd';

export default function ReviewListSection() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState('실손보험');

  const menu = (
    <Menu
      onClick={({ key }) => setSelectedType(key)}
      items={[
        { key: '전체', label: '전체' },
        { key: '실손보험', label: '실손보험' },
        { key: '자동차보험', label: '자동차보험' },
        { key: '배상책임', label: '배상책임' },
        { key: '진단금/기타', label: '진단금/기타' },
      ]}
    />
  );

  return (
    <Wrapper>
      <InnerWrapper>
        <CardSection>
          <CardHeader>
            <CardHeaderContent onClick={() => navigate(`/review?type=실손보험&issue=전체`)}>
              <IconWrapper>
                <InsuranceReviewIcon />
              </IconWrapper>
              <Title>실손 보험금</Title>
            </CardHeaderContent>

            <CardHeaderContent onClick={() => navigate(`/review?type=전체&issue=교통사고`)}>
              <IconWrapper>
                <InsuranceCarIcon />
              </IconWrapper>
              <Title>교통사고</Title>
            </CardHeaderContent>

            <CardHeaderContent onClick={() => navigate(`/review?type=배상책임&issue=전체`)}>
              <IconWrapper>
                <InsurancePersonIcon />
              </IconWrapper>
              <Title>배상책임(누수)</Title>
            </CardHeaderContent>

            <CardHeaderContent onClick={() => navigate(`/review?type=진단금/기타&issue=전체`)}>
              <IconWrapper>
                <InsuranceFeeIcon />
              </IconWrapper>
              <Title>진단금/기타</Title>
            </CardHeaderContent>

            <CardHeaderContent onClick={() => navigate(`/review?type=전체&issue=기타`)}>
              <IconWrapper>
                <InsuranceChatIcon />
              </IconWrapper>
              <Title>기타</Title>
            </CardHeaderContent>
          </CardHeader>
        </CardSection>

        <TextBlockWrapper>
          <TextGroup>
            <StrongGray>나는</StrongGray>
            <Dropdown overlay={menu} trigger={['click']}>
              <HighlightGroup style={{ cursor: 'pointer' }}>
                <StrongBlue>{selectedType}</StrongBlue>
                <BlueArrowIcon />
              </HighlightGroup>
            </Dropdown>
            <StrongGray>관련해서 고민이에요</StrongGray>
          </TextGroup>

          <TextGroup>
            <GrayText>보험사고에 대한 다양한 선임 후기를 둘러보세요</GrayText>
          </TextGroup>
        </TextBlockWrapper>
        <CTAButton
          onClick={() => navigate(`/review?type=${encodeURIComponent(selectedType)}&issue=전체`)}
        >
          <ButtonText>후기 보러가기</ButtonText>
          <InsuranceEyeIcon />
        </CTAButton>
      </InnerWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  padding: 70px 118.883px 70px 119.883px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: #fff;
`;

const InnerWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 1202px;
  padding: 0 16px; /* 좌우 패딩 */
  flex-direction: column;
  align-items: center;
  gap: 108px;
  box-sizing: border-box;
`;

const CardSection = styled.div`
  display: flex;
  padding: 32px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  background: #fff;
`;

const CardHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr); /* 모바일: 1개 */
  gap: 24px;
  width: 100%;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr); /* 태블릿: 3개 한 줄 */
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(5, 1fr); /* PC: 5개 한 줄 */
  }
`;

const Title = styled.h2`
  pointer-events: none; /* ✅ 자식 요소가 hover 이벤트를 가로채지 않도록 설정 */
  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.48px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

const IconWrapper = styled.div`
  display: flex;
  width: 120px;
  height: 120px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1 / 1;
  border-radius: 99px;
  background: var(--table-BG-table_bg02_hov, #f0f3fe);
  transition: transform 0.3s ease;
`;

const CardHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  transition: color 0.3s ease;
  cursor: pointer;

  &:hover ${Title} {
    color: var(--gray-ui_gray01, #191919);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    letter-spacing: -0.48px;
  }

  &:hover ${IconWrapper} {
    transform: scale(1.1);
  }
`;

const TextBlockWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 966px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 0 16px;
  box-sizing: border-box;
`;

const TextGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  text-align: center;
`;

const HighlightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const StrongGray = styled.div`
  color: var(--gray-ui_gray03, #3a3a3a);
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -1px;
  font-size: 50px;

  @media (max-width: 1023px) {
    font-size: 32px;
  }

  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

const StrongBlue = styled(StrongGray)`
  color: var(--Primary-brand_01, #0b46dd);
`;

const GrayText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--gray-ui_gray03, #3a3a3a);
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -1px;
  font-size: 50px;
  width: auto;
  height: auto;
  white-space: nowrap;
  @media (max-width: 1023px) {
    font-size: 32px;
  }

  @media (max-width: 767px) {
    font-size: 24px;
    text-align: center;
  }
`;

const CTAButton = styled.button`
  display: flex;
  width: 330px;
  height: 72px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 99px;
  background: var(--Primary-brand_01, #0b46dd);
  border: none;
  cursor: pointer;

  @media (max-width: 767px) {
    width: 100%;
    max-width: 280px;
    height: 56px;
    font-size: 18px;
  }
`;

const ButtonText = styled.span`
  color: var(--Primary-white, #fff);
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.48px;
  font-size: 24px;

  @media (max-width: 767px) {
    font-size: 18px;
  }
`;
